import React from 'react';

import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { GENERATE_PROGRESS_SELF_CORRECT_PREFIX } from '../GenerateExpression.constants';
import {
  progressTrailDetailStyles,
  progressTrailItemStyles,
  progressTrailSelfCorrectStyles,
} from '../GenerateExpression.styles';
import { GenerateExpressionTestIds } from '../GenerateExpression.testIds';

const ProgressTrailRow = ({ phase, detail = null, isSelfCorrect = false }) => {
  const rowStyles = isSelfCorrect ? progressTrailSelfCorrectStyles : progressTrailItemStyles;
  const rowTestId = isSelfCorrect
    ? GenerateExpressionTestIds.MODAL_PROGRESS_TRAIL_SELF_CORRECT
    : GenerateExpressionTestIds.MODAL_PROGRESS_TRAIL_ITEM;
  const phaseLabel = isSelfCorrect ? `${GENERATE_PROGRESS_SELF_CORRECT_PREFIX} ${phase}` : phase;
  const trimmedDetail = _.trim(detail);

  return (
    <Box data-testid={rowTestId} sx={rowStyles}>
      <Typography color={isSelfCorrect ? 'warning.dark' : 'text.primary'} variant="regular12">
        {phaseLabel}
      </Typography>
      {!_.isEmpty(trimmedDetail) && (
        <Box component="code" sx={progressTrailDetailStyles}>
          {trimmedDetail}
        </Box>
      )}
    </Box>
  );
};

ProgressTrailRow.propTypes = {
  phase: PropTypes.string.isRequired,
  detail: PropTypes.string,
  isSelfCorrect: PropTypes.bool,
};

export default ProgressTrailRow;
